/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ yearly_price: NonNullable<unknown> }} Subscription_Footer_YearlyInputs */

const en_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} per year, cancel anytime.`)
};

const ar_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} سنويًا، يمكنك الإلغاء في أي وقت.`)
};

const de_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} pro Jahr, jederzeit kündbar.`)
};

const es_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} al año, cancelación en cualquier momento.`)
};

const fr_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} par an, résiliable à tout moment.`)
};

const it_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} all'anno, annulla in qualsiasi momento.`)
};

const ja_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/年、いつでもキャンセル可能です。`)
};

const ko_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`연간 ${i?.yearly_price}, 언제든 취소할 수 있어요.`)
};

const pt_br_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} por ano. Cancele a qualquer momento.`)
};

const ru_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} в год, отмена в любое время.`)
};

const th_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price} ต่อปี ยกเลิกได้ตลอดเวลา`)
};

const tr_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık ${i?.yearly_price}, istediğin zaman iptal edebilirsin.`)
};

const zh_cn_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年 ${i?.yearly_price}，随时可以取消。`)
};

const zh_tw_subscription_footer_yearly = /** @type {(inputs: Subscription_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年 ${i?.yearly_price}，隨時可以取消。`)
};

/**
* | output |
* | --- |
* | "{yearly_price} per year, cancel anytime." |
*
* @param {Subscription_Footer_YearlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_footer_yearly = /** @type {((inputs: Subscription_Footer_YearlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Footer_YearlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_footer_yearly(inputs)
	if (locale === "ar") return ar_subscription_footer_yearly(inputs)
	if (locale === "de") return de_subscription_footer_yearly(inputs)
	if (locale === "es") return es_subscription_footer_yearly(inputs)
	if (locale === "fr") return fr_subscription_footer_yearly(inputs)
	if (locale === "it") return it_subscription_footer_yearly(inputs)
	if (locale === "ja") return ja_subscription_footer_yearly(inputs)
	if (locale === "ko") return ko_subscription_footer_yearly(inputs)
	if (locale === "pt_br") return pt_br_subscription_footer_yearly(inputs)
	if (locale === "ru") return ru_subscription_footer_yearly(inputs)
	if (locale === "th") return th_subscription_footer_yearly(inputs)
	if (locale === "tr") return tr_subscription_footer_yearly(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_footer_yearly(inputs)
	return zh_tw_subscription_footer_yearly(inputs)
});